import styled from "../../../styled/index";
export const LinkTag = styled("a") `
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`;
export const LinkTagSuccess = styled("a") `
  color: ${({ theme }) => theme.colors.success};
`;
export const LinkTagError = styled("a") `
  color: ${({ theme }) => theme.colors.error};
`;
//# sourceMappingURL=index.js.map